define('viewModels/privileged/qm/policies/editors/EvaluationFormSelectorView',[
    'lib/lodash4',
    'lib/bluebird',
    'lib/knockout',
    'moment',
    'services/composer/evaluationFormService',
    'viewModels/ViewModel'
], function (_,
             Promise,
             ko,
             moment,
             evaluationFormService,
             ViewModel) {
    'use strict';

    /**
     * The EvaluationFormSelectorView class.
     * @class
     */
    var EvaluationFormSelectorView = ViewModel.extend(function (evaluationFormObservable) {
        var self = this;

        self.loading = ko.observable(false);

        self.evaluationForm = evaluationFormObservable;

        self.placeholderText = ko.i18n.renderString('evaluationFormSelector.placeholderText');

        self.getPublishedEvaluationForms = function (searchTerm) {
            return evaluationFormService.get.published.page({name: searchTerm, onlyLatestPerContext: true }).then(function (evaluationFormsPage) {
                // Make sure evaluation forms from evalFormService get unwrapped.
                // They are initialized with utility functions for editing and validating
                // (that we don't care about) which cause the model to be rejected
                // by the service otherwise.
                var evalForms = _.invokeMap(evaluationFormsPage.asList(), 'unwrap');

                return evalForms;
            });
        };

        if (_.isArray(self.evaluationForm())) {
            self.evaluationForm.extend({deepComparer: true, minLength: {params: 1, message: "evaluationFormSelector.noFormSelected"}});
        } else {
            self.evaluationForm.extend({required: true});
        }

    }, true /* pass args to extended class */);

    return EvaluationFormSelectorView;
});

